import { render, staticRenderFns } from "./VaccineHistoryReport.vue?vue&type=template&id=aa2e1a04&scoped=true&"
import script from "./VaccineHistoryReport.vue?vue&type=script&lang=js&"
export * from "./VaccineHistoryReport.vue?vue&type=script&lang=js&"
import style0 from "./VaccineHistoryReport.scss?vue&type=style&index=0&id=aa2e1a04&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa2e1a04",
  null
  
)

/* custom blocks */
import block0 from "./VaccineHistoryReport.vue?vue&type=custom&index=0&blockType=link&rel=stylesheet&href=https%3A%2F%2Funpkg.com%2Fbootstrap-vue%40latest%2Fdist%2Fbootstrap-vue.min.css"
if (typeof block0 === 'function') block0(component)

export default component.exports